/** Destination-local wall times can have zero, one or two UTC instants at DST changes. */
export function localTimeCandidates(value: string, timezone: string): string[] {
  if (!/^20\d{2}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value) || !timezone || /^[+-]/.test(timezone)) return [];
  const nominal = Date.parse(`${value}:00Z`);
  if (!Number.isFinite(nominal) || new Date(nominal).toISOString().slice(0, 16) !== value) return [];
  try {
    const formatter = new Intl.DateTimeFormat("en-GB", { timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" });
    const format = (instant: number) => {
      const parts = formatter.formatToParts(new Date(instant));
      const part = (kind: Intl.DateTimeFormatPartTypes) => parts.find(item => item.type === kind)?.value ?? "";
      return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
    };
    const offsets = new Set<number>();
    for (let hours = -48; hours <= 48; hours += 6) {
      const sample = nominal + hours * 3_600_000;
      offsets.add(Date.parse(`${format(sample)}:00Z`) - sample);
    }
    return [...offsets].map(offset => nominal - offset).filter(instant => format(instant) === value)
      .sort((a, b) => a - b).map(instant => new Date(instant).toISOString());
  } catch { return []; }
}

export function instantToLocalInput(value: string | null | undefined, timezone: string): string {
  if (!value || !Number.isFinite(Date.parse(value))) return "";
  try {
    const parts = new Intl.DateTimeFormat("en-GB", { timeZone: timezone, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date(value));
    const part = (kind: Intl.DateTimeFormatPartTypes) => parts.find(item => item.type === kind)?.value ?? "";
    return `${part("year")}-${part("month")}-${part("day")}T${part("hour")}:${part("minute")}`;
  } catch { return ""; }
}
